module.exports = __webpack_public_path__ + "img/cog.ca9110d1.svg";